import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-34",
  "use": "icon-icon-nav-34-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-34\"><path d=\"M160 704v96H256c0-53.12-42.88-96-96-96z m0-128v64A160 160 0 0 1 320 800h64C384 676.16 283.84 576 160 576z m576-224h-448v52.16A417.088 417.088 0 0 1 555.84 672H736v-320zM160 448v64A288 288 0 0 1 448 800h64A352 352 0 0 0 160 448z m640-224h-576c-35.2 0-64 28.8-64 64V384h64V288h576v448H576v64h224c35.2 0 64-28.8 64-64v-448c0-35.2-28.8-64-64-64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-34.svg
// module id = IExl
// module chunks = 3